import script from "./GenericComments.vue?vue&type=script&setup=true&lang=js"
export * from "./GenericComments.vue?vue&type=script&setup=true&lang=js"

import "./GenericComments.vue?vue&type=style&index=0&id=1a63f6bf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a63f6bf"]])

export default __exports__